import React from 'react';
import AccountsManagementView from './AccountsManagementView';

const AccountsManagementContainer = (props) => {
  return <AccountsManagementView {...props} />;
};

export default AccountsManagementContainer;
